import { cn } from '@/lib/utils';
import Link from 'next/link';
import ImageWithFallback from '../shared/ImageWithFallback';
import clsx from 'clsx';
import { TrendingItemsType } from '@/lib/types/customer/TrendingItemsType';
import { pushEvent } from '@/lib/utils/functions';

interface ShopProductCardProps {
  trendingItem: TrendingItemsType;
  wrapperClassName?: string;
}

const ShopProductCard = ({
  trendingItem,
  wrapperClassName,
}: ShopProductCardProps) => {
  const CardContent = (
    <>
      <div className="relative h-[185px] w-full overflow-hidden rounded-t-lg bg-gray-100">
        <ImageWithFallback
          src={trendingItem.media?.image?.[0]?.thumb_url || ''}
          fill
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
          alt={trendingItem.title}
          className={clsx(
            'transition-all duration-500 ease-linear group-hover:scale-105',
            trendingItem.media.image[0].thumb_url
              ? 'object-cover'
              : 'object-contain p-4'
          )}
          priority
        />
      </div>
      <div className="p-4 pb-7">
        {trendingItem.badge && (
          <div className="inline-flex items-center justify-center space-x-1 truncate rounded-3xl border-2 border-pink-200 bg-pink-50 px-[clamp(0.5rem,1vw,1.25rem)] py-2 text-[clamp(0.68rem,1vw,0.75rem)] text-pink-500">
            <span className="font-medium leading-[14px]">
              {trendingItem.badge}
            </span>
          </div>
        )}
        <h3 className="mb-2 mt-3 line-clamp-2 text-h6 font-semibold text-title">
          {trendingItem.title}
        </h3>
        {trendingItem.description && (
          <div
            className="text-base leading-[150%] text-paragraph"
            dangerouslySetInnerHTML={{
              __html: trendingItem.description,
            }}
          />
        )}
      </div>
    </>
  );

  const baseClassName = cn(
    'group block overflow-hidden rounded-lg bg-white transition-shadow shadow-sm hover:shadow-card border border-gray-100',
    wrapperClassName
  );

  if (trendingItem?.link) {
    return (
      <Link
        href={trendingItem.link}
        target="_blank"
        rel="noopener noreferrer"
        className={baseClassName}
        onClick={() => {
          pushEvent({
            event: 'shop_product_click',
            eventOptions: {
              shop_product_id: trendingItem.id,
              shop_product_title: trendingItem.title,
              shop_product_slug: trendingItem.slug,
            },
          });
        }}
      >
        {CardContent}
      </Link>
    );
  }

  return <div className={baseClassName}>{CardContent}</div>;
};

export default ShopProductCard;
